;(function () {
    let allFilterHeadings = document.querySelectorAll('.filters__title')
    let filterForm = document.querySelector('form.filters')

    if (!allFilterHeadings.length || !filterForm) {
        return
    }

    allFilterHeadings.forEach((el, index) => {
        el.addEventListener('click', function () {
            el.parentNode.classList.toggle('open')
        })
    })

    let allFilterOptions = document.querySelectorAll('.filters input')

    allFilterOptions.forEach(function (el, index) {
        el.addEventListener('change', function () {
            filterForm.submit()
        })
    })

    function initFilterButton() {
        console.log('in here')
        const filterButton = document.getElementById('filter-button')
        const collectionContainer = document.querySelector(
            '.collection-container'
        )
        console.log('collection: ', collectionContainer)
        filterButton.addEventListener('click', (event) => {
            if (collectionContainer.classList.contains('no-filters')) {
                collectionContainer.classList.remove('no-filters')
            } else {
                collectionContainer.classList.add('no-filters')
            }
        })

        if (window.location.search) {
            if (collectionContainer.classList.contains('no-filters')) {
                collectionContainer.classList.remove('no-filters')
            }
        }
    }

    initFilterButton()
})()
